export default {
    url: 'products/powerocean-single-phase',
    include: ['cn'],
};
